module.exports = __webpack_public_path__ + "static/media/manaus-am.2ad3d602.jpg";